@if (value() !== null) {
	<div
		class="score-circle"
		[class.score-circle--sm]="size() === 'sm'"
		[class.score-circle--lg]="size() === 'lg'"
	>{{ value() }}</div>
}
